"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Frozen_native_exports = {};
__export(Frozen_native_exports, {
  Frozen: () => Frozen
});
module.exports = __toCommonJS(Frozen_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_hooks = require("./hooks");
function Frozen(param) {
  var { on = false, children } = param;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_hooks.FrozeContext.Provider, {
    value: on,
    children
  });
}
//# sourceMappingURL=Frozen.native.js.map
